/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ItemTile_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"ItemTileBase_viewer">;
    readonly " $refType": "ItemTile_viewer";
};
export type ItemTile_viewer$data = ItemTile_viewer;
export type ItemTile_viewer$key = {
    readonly " $data"?: ItemTile_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"ItemTile_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "ItemTile_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "fetchRegionalInfo",
      "type": "Boolean",
      "defaultValue": false
    },
    {
      "kind": "LocalArgument",
      "name": "userZipCode",
      "type": "String",
      "defaultValue": ""
    },
    {
      "kind": "LocalArgument",
      "name": "userCountryCode",
      "type": "String",
      "defaultValue": ""
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ItemTileBase_viewer",
      "args": [
        {
          "kind": "Variable",
          "name": "fetchRegionalInfo",
          "variableName": "fetchRegionalInfo"
        },
        {
          "kind": "Variable",
          "name": "userCountryCode",
          "variableName": "userCountryCode"
        },
        {
          "kind": "Variable",
          "name": "userZipCode",
          "variableName": "userZipCode"
        }
      ]
    }
  ]
};
(node as any).hash = 'd5ea541b7b882382cf7f89a72fc42190';
export default node;
